import axios from "axios";

// URL relativa: o mesmo build funciona em qualquer domínio (preview e produção),
// pois o ingress da plataforma roteia /api para o backend na mesma origem.
const API = "/api";

export const submitLead = (payload) => axios.post(`${API}/leads`, payload);

export const verifyInvite = (code) =>
  axios.get(`${API}/invite/verify`, { params: { code } });
